import React from "react";
import ContainerExpenses from "./container";

export default function Index() {
 

  return <ContainerExpenses />;
}
